const hideStagingFields = [
  'custom_fields.cf_company',
  'priority',
  'custom_fields.cf_type_of_exporter_account',
  'product_id',
  'custom_fields.cf_reference_number',
  'type',
  'custom_fields.cf_request_source'
]

const stagingFields = {
  cf_request_source: 'RF Portal' // request source
}

export const freshdeskMixin = {
  methods: {
    showAndPrefillFreshdesk(customFields, subject) {
      this.resetFreshdeskWidget()
      const { account } = this.$store.state.account
      if (account.parent_user_permissions['freshdesk_enabled?']) {
        window.FreshworksWidget('show')
        window.FreshworksWidget('show', 'launcher')
        window.FreshworksWidget('hide', 'ticketForm', [
          'subject',
          'custom_fields.cf_am_email',
          'custom_fields.cf_cs_email',
          'custom_fields.cf_importer_id',
          'custom_fields.cf_exporter_id',
          'custom_fields.cf_invoice_id',
          'custom_fields.cf_client_id',
          'custom_fields.cf_spam',
          'custom_fields.cf_query_channel',
          'custom_fields.cf_internal_channel',
          'custom_fields.cf_exporter_name',
          'custom_fields.cf_importer_name',
          'custom_fields.cf_invoice_reference',
          'custom_fields.cf_link_to_dashboard',
          'custom_fields.cf_topic',
          'custom_fields.cf_portal_source',
          'custom_fields.cf_details',
          'custom_fields.cf_topic432757',
          ...hideStagingFields
        ])
        window.FreshworksWidget('prefill', 'ticketForm', {
          name: this.$store.getters.user.name,
          email: this.$store.getters.user.email,
          subject:
            subject || `Support Ticket | ${account.company} | Drip Capital`,
          custom_fields: {
            cf_exporter_id: account.id,
            cf_exporter_name: account.company,
            cf_importer_id: null,
            cf_importer_name: '',
            cf_client_id: null,
            cf_invoice_id: null,
            cf_invoice_reference: '',
            cf_link_to_dashboard:
              customFields.cf_link_to_dashboard ||
              `${process.env.VUE_APP_DRIP_ADMIN_HOST}/admin/exporter_applications/${account.id}`,
            cf_am_email: account.am.email || 'NOT ADDED',
            cf_cs_email: account.cs.email || '',
            cf_spam:
              process.env.VUE_APP_ENVIRONMENT === 'production'
                ? 'Non Spam'
                : 'Spam',
            cf_category_i: null,
            cf_query_channel: 'Portal',
            cf_topic: 'Other',
            cf_topic432757: 'Other',
            cf_portal_source: 'RF Portal', // request source
            ...stagingFields,
            ...customFields
          }
        })
      } else {
        window.FreshworksWidget('hide', 'launcher')
      }
    },
    resetFreshdeskWidget() {
      const { account } = this.$store.state.account
      if (account.parent_user_permissions['freshdesk_enabled?']) {
        window.FreshworksWidget('prefill', 'ticketForm', {
          name: this.$store.getters.user.name,
          email: this.$store.getters.user.email,
          subject: `Support Ticket | ${account.company} | Drip Capital`,
          custom_fields: {
            cf_exporter_id: account.id,
            cf_exporter_name: account.company,
            cf_importer_id: '',
            cf_importer_name: '',
            cf_client_id: '',
            cf_invoice_id: '',
            cf_invoice_reference: '',
            cf_link_to_dashboard: `${process.env.VUE_APP_DRIP_ADMIN_HOST}/admin/exporter_applications/${account.id}`,
            cf_am_email: account.am.email || '',
            cf_cs_email: account.cs.email || '',
            cf_spam:
              process.env.VUE_APP_ENVIRONMENT === 'production'
                ? 'Non Spam'
                : 'Spam',
            cf_category_i: '',
            cf_query_channel: 'Portal'
          }
        })
      }
    },
    hideFreshdeskWidget() {
      window.FreshworksWidget('hide', 'launcher')
    }
  }
}
